import { UserMemberSubscriptionHistoryStatus } from "@gymflow/types";
import { useQuery } from "@tanstack/react-query";
import { useClubSettings } from "apps/portal/src/providers";
import { apiV2 } from "libs/api/src/lib/apiV2";
import { capitalize } from "lodash";
import { DateTime } from "luxon";
import React from "react";

import { Badge, BadgeProps } from "../../atoms";

export interface MembershipStatusHistoryProps {
  memberId: string;
}

export const MembershipStatusHistory: React.FC<
  MembershipStatusHistoryProps
> = ({ memberId }) => {
  const { club } = useClubSettings();
  const { data: membershipStatusHistory } = useQuery(
    apiV2.staff.subscription.queries.getMembershipStatusHistory(memberId),
  );
  return (
    <div className="flex w-full flex-col gap-4 pb-4">
      <div className="flex flex-col">
        <div className="flex h-9 items-center text-lg font-semibold text-gray-900">
          Membership Status History
        </div>
        <div className="text-sm font-normal text-slate-600">
          See all membership status changes for this member.
        </div>
      </div>
      {membershipStatusHistory?.map((e) => (
        <div className="flex flex-col gap-4" key={e.id}>
          <div className="border-b border-gray-200" />
          <div className="flex flex-col gap-1">
            <div className="flex flex-row items-center gap-1 text-sm font-semibold text-slate-700">
              Membership status changed to
              <Badge
                intent={membershipColorMap[e.status]}
                className="h-5 text-xs"
              >
                {capitalize(e.status)}
              </Badge>
            </div>

            <div className="text-sm font-normal text-slate-600 ">
              {DateTime.fromISO(e.createdDate)
                .setZone(club.timezone)
                .toLocaleString(DateTime.DATE_MED)}{" "}
              @{" "}
              {DateTime.fromISO(e.createdDate)
                .setZone(club.timezone)
                .toLocaleString(DateTime.TIME_SIMPLE)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const membershipColorMap = {
  ACTIVE: "success",
  PAUSED: "warning",
  PENDING: "primary",
  OVERDUE: "error",
  CANCELLED: "default",
  DELETED: "error",
  EXPIRED: "default",
  CHANGED: "warning",
  DOWNGRADED: "error",
  UPGRADED: "secondary",
} satisfies {
  [key in UserMemberSubscriptionHistoryStatus]: BadgeProps["intent"];
};
